module.exports = __webpack_public_path__ + "static/hero-hcp-dosing-98dbadd6e92e64110b2fb493ed183b54.png";